import { get, put } from 'lib/API';

export const getEmailPermissionsByRole = async (roleId: number, { token }: any): Promise<any> => {
  return await get(`v1/email-permissions/${roleId}`, token);
};

export const updateEmailPermissions = async (updates: any, { token }: any): Promise<any> => {
  return await put(`v1/email-permissions`, token, updates);
};
